import { FC } from 'react'

import { useNavigate } from 'react-router-dom'
import styled from 'styled-components'

import { ArtistProtection } from 'src/Components/ArtistProtection'
import { device } from 'src/Styled/variables'
import { useCustomSearchParams } from 'src/Hooks/useCustomSearchParams'
import { LoadingSpinner } from 'src/Containers/ui'
import { subscription } from 'src/Router/routes'

import { HeaderTitle } from '../components/HeaderTitle'

import { PlanToPay } from './PlanToPay'
import { Payment } from './Payment'
import { useRedirectFromEmail } from './useRedirectFromEmail'

export const PageContainer = styled.div`
  padding: 16px;
  padding-top: 64px;
  padding-bottom: 24px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: 40px;
  max-width: 600px;
  height: fit-content;

  @media ${device.mobileMax} {
    padding: 16px;
  }
`
const StyledHeaderTitle = styled(HeaderTitle)`
  margin-bottom: 0px;
`

const StyledLoadingSpinner = styled(LoadingSpinner)`
  position: fixed;
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(255, 255, 255, 0.7);
  z-index: 999;
`

export const PaySubscription: FC = () => {
  const navigate = useNavigate()
  const { search } = useCustomSearchParams()
  const autopay = search.get('autopay') === 'true'
  useRedirectFromEmail()

  const handleClose = (): void => {
    navigate(subscription)
  }

  return (
    <>
      {autopay && (
        <StyledLoadingSpinner fullscreen color='green' size='large' />
      )}
      <StyledHeaderTitle onClose={handleClose}>
        Subscription order
      </StyledHeaderTitle>
      <PageContainer>
        <PlanToPay />
        <Payment />
        <ArtistProtection>
          You are covered under our artist protection program. If your track is
          not reviewed, then you will be automatically credited.
        </ArtistProtection>
      </PageContainer>
    </>
  )
}
